export default __webpack_public_path__ + "static/media/gestureSensor.349daa22.svg";